import { useContext } from "react";

import DeleteOfflineLicense from "components/Actions/dialogs/Licenses/OfflineLicenses/Inline/DeleteOfflineLicense";
import { useOfflineLicenseInlineActions } from "components/Actions/InlineActions";
import Table from "components/Table";
import TableContext from "context/table/tableContext";
import {
    OFFLINE_LICENSE_COLUMNS as COLUMNS,
    ID_TYPE,
    TABLE_NAMES
} from "shared";

const OfflineLicenses = () => {
    const { detailsData } = useContext(TableContext);

    const { inlineActions, rowData, isOpen, closeDialog } =
        useOfflineLicenseInlineActions();

    const { offline_licenses } = detailsData;

    return (
        <>
            <Table
                name={TABLE_NAMES.OfflineLicenses}
                isInnerTable
                customData={offline_licenses}
                hasNoToolbar
                initialColumns={COLUMNS}
                inlineActions={inlineActions}
                sortFromNewest
                isNotSelectable
                idType={ID_TYPE.Id}
                customStyle={{ marginTop: "16px" }}
            />

            <DeleteOfflineLicense
                data={rowData}
                isOpen={isOpen}
                close={closeDialog}
            />
        </>
    );
};

export default OfflineLicenses;
